import { ImagilityBaseResponse } from 'app-models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})

export class VisaDesignerService {
  manageVisaFilterChanged = new Subject<any>();
  getVisaInfo = new BehaviorSubject<any>({});
  visaType: string = '';
  currentStepName: string = '';
  buildStepsSelectedData: any[] = [];
  currentSelectedPDF = '';
  encriptedData: string;

  constructor(private http: HttpClient) { }

  getCountryList() {
    return this.http.get(`/vd/countries`).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  getLanguageAndFormType(countryCode) {
    return this.http.get(`/vd/langAndFormType?countryCode=${countryCode}`).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  getAllDependentDataByFormType(payload) {
    return this.http.post(`/vd/visaType`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  createVisa(payload) {
    return this.http.post(`/vd/taskType`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  checkDuplicateVisaName(payload) {
    return this.http.post(`/vd/taskType/duplicateVisaNameCheck `, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  duplicateVisa(payload, type) {
    return this.http.post(`/vd/${type}/taskType`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  rePublishVisa(payload) {
    return this.http.post(`/vd/republish/taskType`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  getCreatedVisaList(payload) {
    return this.http.post(`/vd/manage/created`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  postCustomRadioImage(id, payload) {
    let customUrl;
    if (id) {
      customUrl = `/vd/formBuilder/uploadImage?id=${id}`
    } else {
      customUrl = `/vd/formBuilder/uploadImage`
    }

    return this.http.post(customUrl, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  getVisaById(visaId) {
    return this.http.get(`/vd/taskType/${visaId}`).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }
  deleteVisa(visaId) {
    return this.http.delete(`/vd/taskType/${visaId}`).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  getAllPlaceHolderList(taskTypeRefId, visaId) {
    return this.http.post(`/vd/${taskTypeRefId}/taskType/${visaId}/masterPlcHldrs`, {}).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  getStepsList(payload) {
    return this.http.post(`/vd/steps`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }
  getFeeMasterData(taskType, payload) {
    return this.http.post(`/vd/${taskType}/fees`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }
  // publishVisa(visaId) {
  //   return this.http.post(`/vd/taskType/${visaId}/publish`, {}).pipe(
  //     map((response: ImagilityBaseResponse) => {
  //       return response;
  //     })
  //   );
  // }

  publishVisa(visaId, isRepublishVisa) {
    return this.http.post(`/vd/taskType/${visaId}/${isRepublishVisa}/publish`, {}).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  getDefaultLetterTemplate(visaId, docType) {
    return this.http.get(`/vd/taskType/${visaId}/${docType}/template`).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  saveDefaultLetterTemplate(visaId, docType, payload) {
    return this.http.post(`/vd/taskType/${visaId}/${docType}/template`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  getServiceCenterList(payload) {
    return this.http.post(`/vd/serviceCenters`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }


  getPlaceHolderControls(payload: object) {
    return this.http.post<any>(`/vd/controls`, payload).pipe(map((data: ImagilityBaseResponse) => {
      return data;
    }));
  }

  getTimelinePlaceHolderControls(payload: object) {
    return this.http.post<any>(`/vd/controls`, payload).pipe(map((data: ImagilityBaseResponse) => {
      return data;
    }));
  }

  saveTaskDetailsTemplates(payload: object) {
    return this.http.post<any>(`/vd/taskType`, payload).pipe(map((data: ImagilityBaseResponse) => {
      return data;
    }));
  }

  getTaskDetailsTemplates(visaId: any) {
    return this.http.get<any>(`/vd/taskType/` + visaId).pipe(map((data: ImagilityBaseResponse) => {
      return data;
    }));
  }

  deleteTaskDetailsTemplates(visaId: any) {
    return this.http.delete<any>(`/vd/taskType/` + visaId).pipe(map((data: ImagilityBaseResponse) => {
      return data;
    }));
  }

  getDataSources() {
    return this.http.get(`/vd/dataSource`).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  getDocumentTypes() {
    return this.http.get(`/vd/documentTypes`).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }



  formMappingPlaceholders(visaId: any) {
    return this.http.get<any>(`/vd/taskType/` + visaId + `/forms/placeholders`).pipe(map((data: ImagilityBaseResponse) => {
      return data;
    }));
  }

  formMappingPagesCount(visaId: any) {
    return this.http.post(`/vd/forms`, {}).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  // Form-Mapping-Page-Number

  formMappingFetchPageNumber(visaId: any, page) {    
    return this.http.get<any>(`/vd/taskType/` + visaId + `/form/` + page).pipe(map((data: ImagilityBaseResponse) => {
      return data;
    }));
  }

  getFormTypes(payload) {
    return this.http.post(`/vd/forms`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }
  getTaskDetailsTemplatesByStepId(stepId: any) {
    return this.http.get<any>(`/vd/step/${stepId}/info`).pipe(map((data: ImagilityBaseResponse) => {
      return data;
    }));
  }

  getUsedObjectsFromVisaPDFtoWorkflow(taskTypeJsonId: number) {
    return this.http.get(`/vd/pdfToWorkflow/get/customeListFromStepJson/${taskTypeJsonId}`)
      .pipe(map((response: ImagilityBaseResponse) => {
        if (response && response.status === 200 && response.data &&
          response.data.customStepList &&
          response.data.customStepList.length > 0) {
          return response.data.customStepList;
        } else {
          return [];
        }
      }));
  }

  tempJSONFunc(taskTypeJsonId: number) {
    return this.http.get(
      `/vd/pdfToWorkflow/get/formAutomation/jsonViewerFormsList/${taskTypeJsonId}`
    ).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response && response.status === 200 && response.data) {
          const data = (JSON.parse(response.data));
          const jsonViewerFormsListResponse = data.jsonViewerFormsListResponse && data.jsonViewerFormsListResponse.length > 0 ?
            data.jsonViewerFormsListResponse : null;
          return jsonViewerFormsListResponse;
        } else {
          return null;
        }
      })
    );
  }


  oldTempJSONFunc(taskTypeJsonId: number) {
    return this.http.get(`/vd/pdfToWorkflow/get/formAutomation/${taskTypeJsonId}`)
      .pipe(map((response: ImagilityBaseResponse) => {
        if (response && response.status === 200 && response.data &&
          response.data.pdfResponseList &&
          response.data.pdfResponseList.length > 0) {
          return response.data.pdfResponseList;
        } else {
          return null;
        }
      }));
  }



  newVdPdfEngine(jsonObj: any, usedElements: any[]) {
    const resultJSON = [];
    jsonObj.filter(x => x).forEach((obj: any) => {
      const tempJSON = {
        fileName: obj.fileName,
        elementList: []
      };
      const elementJSONObj = (JSON.parse(obj.elementsJSONResponseListAsString) as any[]);
      const isJSONConvertedObj = elementJSONObj.find(x => x.isJSONConverted);
      if (isJSONConvertedObj) {
        elementJSONObj.splice(elementJSONObj.findIndex(x => x.isJSONConverted), 1);
        tempJSON.elementList.push(...elementJSONObj.filter(x => x.getFieldType !== 'groupTitle'));
        resultJSON.push(tempJSON);
      }
    });
    return this.segregateUsedAndUnusedElements(resultJSON, usedElements);
  }

  oldVdPdfEngine(jsonObj: any, usedElements: any[]) {
    const resultJSON = [];
    const defaultJson = [];
    const repeatedElementTitle = [];
    const emptyDataFieldName = [];
    jsonObj.forEach((obj: any, formIndex: number) => {
      const allElementTitle = [];
      const tempJSON = {
        fileName: obj.fileName,
        elementList: []
      };
      (obj.partsResponseList as any[]).sort((a, b) => {
        const stringA = String(a.partName).toLowerCase();
        const stringB = String(b.partName).toLowerCase();
        const partA = stringA.indexOf('part') === 0 ?
          Number(stringA.match(/\d+/)[0]) : 0;
        const partB = stringB.indexOf('part') === 0 ?
          Number(stringB.match(/\d+/)[0]) : 0;
        return partA - partB;
      }).forEach((part: any, partIndex: number) => {
        let elementTitle = this.removeSerialNumber(part.partName);
        tempJSON.elementList.push({
          fileName: obj.fileName,
          elementTitle,
          fieldType: 'partTitle',
          checked: false,
          numberOfRow: null,
          numberOfColumn: null,
          data_field_name: `part_${formIndex}_${partIndex}`,
          elementId: `ele_id_${formIndex}_${partIndex}`,
          disabled: false,
          defaultProperties: {
            data_field_name: `part_${formIndex}_${partIndex}`,
            numberOfRow: null,
            numberOfColumn: null,
            fieldType: 'partTitle',
            name: `${obj.fileName}_part_${formIndex}_${partIndex}`,
            coordinateX: 0,
            coordinateY: 0,
            align: "left",
            checkboxLabel: null,
            controlElementType: "GROUP",
            controlName: "VdLabelComponent",
            controlType: "CUSTOM",
            editMode: false,
            fieldConfiguration: null,
            gridProperties: null,
            gridValues: null,
            groupElementProperty: null,
            groupName: null,
            isChecked: false,
            isConfigurable: false,
            isDisabled: false,
            label: elementTitle,
            layoutCode: "VdLabelComponent",
            mandatory: false,
            maxLength: "10",
            minLength: "5",
            placeholder: "",
            properties: { title: elementTitle },
            questionCheck: false,
            questionText: null,
            readonly: false,
            style: { color: "#000000", width: "100%", fontWeight: "700", fontSize: "20px" },
            subText: "sub Text",
            value: ""
          }
        });
        (part.subHeadingList as any[]).forEach((subHead: any, subHeadIndex: number) => {
          if (String(subHead.subHeadingName).trim() !== '') {
            elementTitle = this.removeSerialNumber(subHead.subHeadingName);
            tempJSON.elementList.push({
              fileName: obj.fileName,
              elementTitle,
              fieldType: 'subHeadingTitle',
              checked: false,
              numberOfRow: null,
              numberOfColumn: null,
              data_field_name: `part_${formIndex}_${partIndex}_${subHeadIndex}`,
              elementId: `ele_id_${formIndex}_${partIndex}_${subHeadIndex}`,
              disabled: false,
              defaultProperties: {
                data_field_name: `part_${formIndex}_${partIndex}_${subHeadIndex}`,
                numberOfRow: null,
                numberOfColumn: null,
                fieldType: 'subHeadingTitle',
                name: `${obj.fileName}_part_${formIndex}_${partIndex}_${subHeadIndex}`,
                coordinateX: 0,
                coordinateY: 0,
                align: "left",
                checkboxLabel: null,
                controlElementType: "GROUP",
                controlName: "VdLabelComponent",
                controlType: "CUSTOM",
                editMode: false,
                fieldConfiguration: null,
                gridProperties: null,
                gridValues: null,
                groupElementProperty: null,
                groupName: null,
                isChecked: false,
                isConfigurable: false,
                isDisabled: false,
                label: elementTitle,
                layoutCode: "VdLabelComponent",
                mandatory: false,
                maxLength: "10",
                minLength: "5",
                placeholder: "",
                properties: { title: elementTitle },
                questionCheck: false,
                questionText: null,
                readonly: false,
                style: { color: "#000000", width: "100%", fontWeight: "600", fontSize: "18px" },
                subText: "sub Text",
                value: ""
              }
            });
          }
          (subHead.elementHeadingList as any[]).forEach((elementHeading: any, elementHeadingIndex: number) => {
            if (String(elementHeading.elementHeadingName).trim() !== '') {
              elementTitle = this.removeSerialNumber(elementHeading.elementHeadingName);
              tempJSON.elementList.push({
                fileName: obj.fileName,
                elementTitle,
                fieldType: 'elementHeading',
                checked: false,
                numberOfRow: null,
                numberOfColumn: null,
                data_field_name: `part_${formIndex}_${partIndex}_${subHeadIndex}_${elementHeadingIndex}`,
                elementId: `ele_id_${formIndex}_${partIndex}_${subHeadIndex}_${elementHeadingIndex}`,
                disabled: false,
                defaultProperties: {
                  data_field_name: `part_${formIndex}_${partIndex}_${subHeadIndex}_${elementHeadingIndex}`,
                  numberOfRow: null,
                  numberOfColumn: null,
                  fieldType: 'elementHeading',
                  name: `${obj.fileName}_part_${formIndex}_${partIndex}_${subHeadIndex}_${elementHeadingIndex}`,
                  coordinateX: 0,
                  coordinateY: 0,
                  align: "left",
                  checkboxLabel: null,
                  controlElementType: "GROUP",
                  controlName: "VdLabelComponent",
                  controlType: "CUSTOM",
                  editMode: false,
                  fieldConfiguration: null,
                  gridProperties: null,
                  gridValues: null,
                  groupElementProperty: null,
                  groupName: null,
                  isChecked: false,
                  isConfigurable: false,
                  isDisabled: false,
                  label: elementTitle,
                  layoutCode: "VdLabelComponent",
                  mandatory: false,
                  maxLength: "10",
                  minLength: "5",
                  placeholder: "",
                  properties: { title: elementTitle },
                  questionCheck: false,
                  questionText: null,
                  readonly: false,
                  style: { color: "#000000", width: "100%", fontWeight: "normal" },
                  subText: "sub Text",
                  value: ""
                }
              });
            }
            const checkboxHandled = [];
            (elementHeading.elementList as any[]).forEach((element: any, elementIndex: number) => {
              element.data_field_name = String(element.data_field_name).trim();
              if (String(element.data_field_name).trim() === '') {
                emptyDataFieldName.push({
                  fieldType: element.fieldType,
                  fileName: obj.fileName,
                  part: part.partName,
                  subHeadingName: subHead.subHeadingName,
                  elementHeadingName: elementHeading.elementHeadingName,
                  elementTitle: element.elementTitle,
                  data_field_name: element.data_field_name
                });
              } else {
                if (allElementTitle.includes(element.data_field_name)) {
                  repeatedElementTitle.push({
                    fieldType: element.fieldType,
                    fileName: obj.fileName,
                    part: part.partName,
                    subHeadingName: subHead.subHeadingName,
                    elementHeadingName: elementHeading.elementHeadingName,
                    elementTitle: element.elementTitle,
                    data_field_name: element.data_field_name
                  });
                } else {
                  allElementTitle.push(element.data_field_name);
                }
              }
              switch (element.fieldType) {
                case 'Dropdown':
                  elementTitle = this.removeSerialNumber(element.elementTitle);
                  tempJSON.elementList.push({
                    fileName: obj.fileName,
                    elementTitle,
                    fieldType: element.fieldType,
                    checked: false,
                    numberOfRow: null,
                    numberOfColumn: null,
                    data_field_name: element.data_field_name,
                    elementId: `ele_id_${formIndex}_${partIndex}_${subHeadIndex}_${elementHeadingIndex}_${elementIndex}`,
                    disabled: false,
                    defaultProperties: {
                      ...element.defaultProperties,
                      fieldType: element.fieldType,
                      numberOfRow: null,
                      numberOfColumn: null,
                      data_field_name: element.data_field_name,
                      controlElementType: 'DROPDOWN',
                      style: {
                        ...element.defaultProperties.styleResponse,
                        width: '100%'
                      },
                      isConfigurable: false,
                      isChecked: false,
                      isDisabled: false,
                      properties: {
                        inputArray: element.dropDownValuesList,
                        isDataFromApi: false,
                        isMultiselect: false,
                        showDataSelection: true,
                        showMultiSelectOption: true,
                        refercenceCodeForApiCall: ''
                      },
                      value: "",
                      name: `${obj.fileName}_${element.data_field_name}`,
                      label: elementTitle,
                      layoutCode: 'CustomDropdownComponent',
                      coordinateX: 0,
                      coordinateY: 0,
                      controlName: 'Dropdown',
                      controlType: 'CUSTOM',
                      align: 'left'
                    },
                    properties: element.dropDownValuesList
                  });
                  break;
                case 'Checkbox':
                  let checkboxId = String(element.data_field_name).substring(0, element.data_field_name.length - 3);
                  if (checkboxId.endsWith('_Male')) {
                    checkboxId = checkboxId.substring(0, checkboxId.length - 5);
                  } else if (checkboxId.endsWith('_Female')) {
                    checkboxId = checkboxId.substring(0, checkboxId.length - 7);
                  }
                  if (checkboxHandled.indexOf(checkboxId) === -1) {
                    checkboxHandled.push(checkboxId);
                    const checkboxList = (elementHeading.elementList as any[])
                      .filter((x) => x.fieldType === 'Checkbox')
                      .filter((x) => {
                        x.data_field_name = String(x.data_field_name).trim();
                        let compareCheckboxId = String(x.data_field_name).substring(0, x.data_field_name.length - 3);
                        if (compareCheckboxId.endsWith('_Male')) {
                          compareCheckboxId = compareCheckboxId.substring(0, compareCheckboxId.length - 5);
                        } else if (compareCheckboxId.endsWith('_Female')) {
                          compareCheckboxId = compareCheckboxId.substring(0, compareCheckboxId.length - 7);
                        }
                        return compareCheckboxId === checkboxId;
                      });
                    const properties = checkboxList.map(x => {
                      return {
                        name: x.elementTitle,
                        isChecked: false,
                        data_field_name: x.data_field_name
                      }
                    });
                    if (checkboxList && checkboxList.length > 0 &&
                      elementHeading.elementList.length === checkboxList.length) {
                      elementTitle = this.removeSerialNumber(elementHeading.elementHeadingName);
                      tempJSON.elementList[tempJSON.elementList.length - 1] = {
                        fileName: obj.fileName,
                        elementTitle,
                        fieldType: 'checkboxWithHeader',
                        checked: false,
                        numberOfRow: null,
                        numberOfColumn: null,
                        data_field_name: checkboxId,
                        alignControl: checkboxList.length > 1 ? 'bottom' : 'left',
                        elementId: `ele_id_${formIndex}_${partIndex}_${subHeadIndex}_${elementHeadingIndex}_${elementIndex}`,
                        disabled: false,
                        defaultProperties: {
                          ...element.defaultProperties,
                          fieldType: element.fieldType,
                          numberOfRow: null,
                          numberOfColumn: null,
                          data_field_name: checkboxId,
                          alignControl: checkboxList.length > 1 ? 'bottom' : 'left',
                          controlElementType: 'CHECKBOX',
                          style: {
                            ...element.defaultProperties.styleResponse,
                            width: '100%'
                          },
                          isConfigurable: false,
                          isChecked: false,
                          isDisabled: false,
                          properties: {
                            inputArray: JSON.parse(JSON.stringify(properties)),
                            isDataFromApi: true,
                            refercenceCodeForApiCall: ''
                          },
                          value: JSON.parse(JSON.stringify(properties)),
                          name: `${obj.fileName}_${checkboxId}`,
                          label: elementTitle,
                          layoutCode: 'CustomCheckboxComponent',
                          coordinateX: 0,
                          coordinateY: 0
                        },
                        properties
                      };
                    } else {
                      elementTitle = this.removeSerialNumber(element.elementTitle);
                      tempJSON.elementList.push({
                        fileName: obj.fileName,
                        elementTitle,
                        fieldType: element.fieldType,
                        checked: false,
                        numberOfRow: null,
                        numberOfColumn: null,
                        data_field_name: checkboxId,
                        alignControl: checkboxList.length > 1 ? 'bottom' : 'left',
                        elementId: `ele_id_${formIndex}_${partIndex}_${subHeadIndex}_${elementHeadingIndex}_${elementIndex}`,
                        disabled: false,
                        defaultProperties: {
                          ...element.defaultProperties,
                          fieldType: element.fieldType,
                          numberOfRow: null,
                          numberOfColumn: null,
                          data_field_name: checkboxId,
                          alignControl: checkboxList.length > 1 ? 'bottom' : 'left',
                          controlElementType: 'CHECKBOX',
                          style: {
                            ...element.defaultProperties.styleResponse,
                            width: '100%'
                          },
                          isConfigurable: false,
                          isChecked: false,
                          isDisabled: false,
                          properties: {
                            inputArray: JSON.parse(JSON.stringify(properties)),
                            isDataFromApi: true,
                            refercenceCodeForApiCall: ''
                          },
                          value: JSON.parse(JSON.stringify(properties)),
                          name: `${obj.fileName}_${checkboxId}`,
                          label: elementTitle,
                          layoutCode: 'CustomCheckboxComponent',
                          coordinateX: 0,
                          coordinateY: 0
                        },
                        properties
                      });
                    }
                  }
                  break;
                case 'Textbox':
                  elementTitle = this.removeSerialNumber(element.elementTitle);
                  tempJSON.elementList.push({
                    fileName: obj.fileName,
                    elementTitle,
                    fieldType: element.fieldType,
                    checked: false,
                    numberOfRow: null,
                    numberOfColumn: null,
                    data_field_name: element.data_field_name,
                    elementId: `ele_id_${formIndex}_${partIndex}_${subHeadIndex}_${elementHeadingIndex}_${elementIndex}`,
                    disabled: false,
                    defaultProperties: {
                      ...element.defaultProperties,
                      fieldType: element.fieldType,
                      numberOfRow: null,
                      numberOfColumn: null,
                      data_field_name: element.data_field_name,
                      layoutCode: 'CustomTextFieldComponent',
                      style: {
                        ...element.defaultProperties.styleResponse,
                        width: '100%'
                      },
                      label: elementTitle,
                      name: `${obj.fileName}_${element.data_field_name}`,
                      coordinateX: 0,
                      coordinateY: 0
                    }
                  });
                  break;
                case 'CALENDAR':
                  elementTitle = this.removeSerialNumber(element.elementTitle);
                  tempJSON.elementList.push({
                    fileName: obj.fileName,
                    elementTitle,
                    fieldType: element.fieldType,
                    checked: false,
                    numberOfRow: null,
                    numberOfColumn: null,
                    data_field_name: element.data_field_name,
                    elementId: `ele_id_${formIndex}_${partIndex}_${subHeadIndex}_${elementHeadingIndex}_${elementIndex}`,
                    disabled: false,
                    defaultProperties: {
                      ...element.defaultProperties,
                      fieldType: element.fieldType,
                      numberOfRow: null,
                      numberOfColumn: null,
                      data_field_name: element.data_field_name,
                      label: elementTitle,
                      name: `${obj.fileName}_${element.data_field_name}`,
                      controlElementType: 'CALENDAR',
                      layoutCode: 'CustomCalenderComponent',
                      editMode: false,
                      isChecked: false,
                      isConfigurable: false,
                      isDisabled: false,
                      mandatory: false,
                      style: {
                        color: '#000',
                        width: '100%',
                        border: '0px',
                        position: 'absolute',
                        background: 'none'
                      },
                      value: null,
                      coordinateX: 0,
                      coordinateY: 0
                    }
                  });
                  break;
                default:
                  defaultJson.push({
                    fieldType: element.fieldType,
                    fileName: obj.fileName,
                    part: part.partName,
                    subHeadingName: subHead.subHeadingName,
                    elementHeadingName: elementHeading.elementHeadingName,
                    elementTitle: element.elementTitle
                  });
                  break;
              }
            });
          });
        });
      });
      resultJSON.push(tempJSON);
    });
    // console.log(JSON.stringify({
    //   jsonErrorList: defaultJson,
    //   repeatedElementDataFieldName: repeatedElementTitle,
    //   emptyDataFieldName
    // }));
    return this.segregateUsedAndUnusedElements(resultJSON, usedElements);
  }

  removeSerialNumber(str: string) {
    const regex = /^[\d|A-Z|a-z]{1,2}\.\s*(.+)$/;
    if (str.match(regex)) {
      // console.log('--------------------');
      // console.log(str);
      str = str.replace(regex, "$1");
      // console.log(str);
      // console.log('--------------------');
    }
    // console.log(str);
    return str;
  }

  segregateUsedAndUnusedElements(resultJSON: any[], usedElements: any[]) {
    try {
      resultJSON = resultJSON.map((form) => {
        return {
          ...form,
          elementList: form.elementList.filter((element) => element.defaultProperties).map((element) => {
            if (!element.defaultProperties) {
              console.log(element);
            }
            return {
              ...element,
              disabled: element.defaultProperties?.name ? usedElements.includes(element.defaultProperties.name) : false,
              checked: false,
              numberOfRow: null,
              numberOfColumn: null,
              defaultProperties: {
                ...element.defaultProperties,
                numberOfRow: null,
                numberOfColumn: null
              }
            };
          })
        };
      });
    } catch (error) {
      console.log(error);
    }
    return resultJSON;
  }

  toEncrypt(_data) {
    var pharase = 'c63a423527b24f65'
    var data = _data;
    var key  = CryptoJS.enc.Latin1.parse(pharase);
    var iv   = CryptoJS.enc.Latin1.parse(pharase);  
    var encrypted = CryptoJS.AES.encrypt(
      data,
      key,
      {iv:iv,mode:CryptoJS.mode.CBC,
        padding:CryptoJS.pad.ZeroPadding
    }).toString();

    var e64 = CryptoJS.enc.Base64.parse(encrypted);
    var eHex = e64.toString(CryptoJS.enc.Hex);

   return this.encriptedData = eHex
  }

}


